import App from './App.svelte'

const app = new App({
  target: document.querySelector('body'),
  props: {
    domain: window.rdy_ride.domain,
    views: window.rdy_ride.views,
    routeIDs: window.rdy_ride.routeIDs,
    ready: false,
  },
})

window.initMap = function ready() {
  app.$set({ ready: true })
}

export default app
